/**
 * Celeb Room emoji reactions.
 *
 * The API accepts an `emoji_id` in the range 1..255 that mirrors the app's
 * `users_emoji` system. The exact server mapping is authoritative; this file is
 * a curated front-end preset used to render pickers and reaction chips.
 *
 * NOTE: keep these ids aligned with the app's users_emoji table. If the backend
 * mapping differs, only this file needs updating.
 */

export const CELEB_ROOM_EMOJIS = [
  { id: 1, char: '\u2764\uFE0F' }, // ❤️
  { id: 2, char: '\uD83D\uDC4D' }, // 👍
  { id: 3, char: '\uD83D\uDE02' }, // 😂
  { id: 4, char: '\uD83D\uDE2E' }, // 😮
  { id: 5, char: '\uD83D\uDE22' }, // 😢
  { id: 6, char: '\uD83D\uDE4F' }, // 🙏
  { id: 7, char: '\uD83D\uDD25' }, // 🔥
  { id: 8, char: '\uD83C\uDF89' }, // 🎉
];

const EMOJI_BY_ID = new Map(CELEB_ROOM_EMOJIS.map((e) => [e.id, e.char]));

/** Returns the emoji character for an id, or a neutral fallback. */
export function emojiCharForId(emojiId) {
  const id = Number(emojiId);
  return EMOJI_BY_ID.get(id) || '\uD83D\uDD18'; // 🔘 fallback
}
